import React from 'react';
import cn from 'classnames';
import {
  Copy,
  Flex,
  Heading,
  Image,
  Stack,
} from '@grubhubprod/gh-cookbook-react/dist';
import {
  Breakpoint,
  useDeviceSize,
} from '@grubhubprod/umami-library/dist/hooks/useDeviceSize';
import { getWindow } from 'src/utilities/window';
import { OnboardingCardDetails } from 'src/components/selfService/features/Signup/steps/LineOfCreditStep/LineOfCreditStep.utils';

interface OnboardingCardProps {
  onboardingCardDetails: OnboardingCardDetails;
  isLastCard: boolean;
}

export function OnboardingCard({
  onboardingCardDetails,
  isLastCard,
}: OnboardingCardProps): JSX.Element {
  const { breakpoint } = useDeviceSize(getWindow());

  const isPhone = breakpoint < Breakpoint.sm;

  const { imageAltText, imageUrl, primaryText, secondaryText } =
    onboardingCardDetails;

  return (
    <Stack y={isPhone && !isLastCard ? 'lg' : 'none'}>
      <Flex flexDirection={isPhone ? 'row' : 'column'} alignItems="center">
        <Stack
          y={isPhone ? 'none' : 'sm'}
          x={isPhone ? 'md' : 'none'}
          flexShrink={isPhone ? 0 : 1}
          maxWidth={120}
          maxHeight={120}
        >
          <Image
            width={isPhone ? '90px' : '100%'}
            src={imageUrl}
            alt={imageAltText}
          />
        </Stack>
        <div
          className={cn('lineOfCreditStep_textContainer', {
            mobile: isPhone,
          })}
        >
          <Stack y="x-sm">
            <Heading variant="h3" textAlign={isPhone ? 'left' : 'center'}>
              {primaryText}
            </Heading>
          </Stack>
          <Copy variant="body" textAlign={isPhone ? 'left' : 'center'}>
            {secondaryText}
          </Copy>
        </div>
      </Flex>
    </Stack>
  );
}
